import React from 'react';
import { CheckCircle } from 'lucide-react';
interface Step {
  number: string;
  title: string;
  description: string;
  outcomes: string[];
}
interface SolutionSlideProps {
  content: {
    steps: Step[];
  };
}
export function SolutionSlide({
  content
}: SolutionSlideProps) {
  return <div className="bg-gradient-to-br from-[#017C6D] to-[#0FB07D] rounded-2xl p-12" data-id="element-188">
      <h2 className="text-4xl font-bold text-white mb-4" data-id="element-189">
        The Viridia AI Framework
      </h2>
      <p className="text-xl text-white/90 mb-12" data-id="element-190">
        Our proven 4-step methodology
      </p>

      <div className="grid grid-cols-2 gap-6" data-id="element-191">
        {content.steps.map((step, index) => <div key={index} className="bg-white rounded-xl p-8" data-id="element-192">
            <div className="text-5xl font-bold text-[#0FB07D] mb-4" data-id="element-193">
              {step.number}
            </div>
            <h3 className="text-2xl font-bold text-[#1C1C1C] mb-3" data-id="element-194">
              {step.title}
            </h3>
            <p className="text-[#4D4D4D] mb-6 leading-relaxed" data-id="element-195">
              {step.description}
            </p>

            <div className="space-y-2" data-id="element-196">
              {step.outcomes.map((outcome, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-197">
                  <CheckCircle size={18} className="text-[#0FB07D] mt-0.5 flex-shrink-0" data-id="element-198" />
                  <span className="text-sm text-[#4D4D4D]" data-id="element-199">{outcome}</span>
                </div>)}
            </div>
          </div>)}
      </div>
    </div>;
}
export default SolutionSlide;